// extracted by mini-css-extract-plugin
module.exports = {"root":"point-card_root__rMcN7","clickable":"point-card_clickable__ajEvc","overlayLink":"point-card_overlayLink__j_mfG","mediaLayer":"point-card_mediaLayer__nBNdG"};